class SearchFeedbackStatistics {

    constructor() {
        this.FromDate = undefined;
        this.ToDate = undefined;
        this.Session = [];
        this.pagingParams = {
            pageNumber: undefined,
            pageSize: undefined
        }
    }
}

export default SearchFeedbackStatistics;

 